<template>
  <div class="flex-between">
    <el-cascader
      :options="options"
      filterable
      size="mini"
      :title="selected.selectValue"
      v-model="selected.selectValue"
      :placeholder="$lange == 'en' ? 'please select' : '请选择'"
    ></el-cascader>
    <el-input
      v-model="selected.inputValue"
      style="max-width: 193px; display: inline-block"
      size="mini"
      :placeholder="$lange == 'en' ? 'Detail information' : '请输入详细地址'"
    ></el-input>
  </div>

  <!--        <el-button @click="downloadJson">导出</el-button>-->
</template>

<script>
const globalArea = require("../json/globalArea");
// const country = require("../json/countries")
// const state = require("../json/states")
// const city = require("../json/cities")
export default {
  name: "GlobalSelect",
  model: {
    prop: "value",
    event: "change",
  },
  watch: {
    selected: {
      handler() {
        this.isChange();
      },
      deep: true,
    },
  },
  props: {
    /**
     * 用于兼容各种应用场景 如( 只想选择某几个国家, 或者某个国家里的省份 )
     * @selectFormat 用于想要选择的格式 ( 例子: C-P-I[默认] || C-P || P-I  {PS: C => Country(国家), P => Province(省份), I => City(城市) } )
     *
     * @showCountry 输入想显示的国家名称字符串 如['中国','美国'], 这样就只会显示中国跟美国的选择
     *               受传入的selectFormat的影响
     *
     * */
    value: {
      type: String,
      required: false,
    },
    selectFormat: {
      type: String,
      required: false,
      default: "C-P-I",
    },
    showCountry: {
      type: Object,
      required: false,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      options: [],
      selected: {
        inputValue: "",
        selectValue: ["中国"],
      },
    };
  },
  methods: {
    selectChange(resArr) {
      this.isChange();
    },
    isChange() {
      let str = this.selected.selectValue.join("-");
      let res = `${str}`;
      if (this.selected.inputValue) {
        res += `/${this.selected.inputValue}`;
      }
      this.value = res;
      this.$emit("change", this.value);
      console.log(this.value);
    },
    initData() {
      let data = globalArea;
      // 国家 + 省份
      if (this.selectFormat === "C-P") {
        for (let i in data) {
          if (data[i].children !== undefined) {
            for (let j in data[i].children) {
              delete data[i].children[j].children;
            }
          }
        }
      }

      this.options = data;
    },
    //用于将3个文件处理成一个json
    // initJSON(){
    //     let res = [];
    //     for(let c in country["RECORDS"]){
    //         let cItem = country["RECORDS"][c];
    //         cItem.label = cItem.cname;
    //         cItem.value = cItem.cname;
    //         for(let s in state["RECORDS"]){
    //             let sItem = state["RECORDS"][s];
    //             sItem.label = sItem.cname;
    //             sItem.value = sItem.cname;
    //             if(sItem.country_id === cItem.id){
    //                 if(cItem.children === undefined){
    //                     cItem.children = [];
    //                 }
    //                 let flag = false;
    //                 for(let cc in cItem.children){
    //                     if(cItem.children[cc].cname === sItem.cname){
    //                         flag = true;
    //                     }
    //                 }
    //
    //                 for(let i in city["RECORDS"]){
    //                     let iItem = city["RECORDS"][i];
    //                     iItem.label = iItem.cname;
    //                     iItem.value = iItem.cname;
    //                     if(sItem.id === iItem.state_id){
    //                         if(sItem.children === undefined){
    //                             sItem.children = [];
    //                         }
    //                         let flag2 = false;
    //                         for(let ss in sItem.children){
    //                             if(sItem.children[ss].cname === iItem.cname){
    //                                 flag2 = true;
    //                             }
    //                         }
    //
    //                         if(!flag2){
    //                             sItem.children.push(iItem);
    //                         }
    //                     }
    //                 }
    //                 if(!flag){
    //                     cItem.children.push(sItem);
    //                 }
    //             }
    //
    //         }
    //         res.push(cItem);
    //     }
    // },

    //用于导出处理后的json 文件
    downloadJSON() {
      let jsonStr = JSON.stringify(this.options);
      let blob = new Blob([jsonStr], { type: "text/plain;charset=UTF-8" });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = url;
      a.download = "globalArea";
      a.click();
    },
  },
  mounted() {
    if (this.value && this.value.length > 0) {
      // let selectStr = this.value.split("/")[0].split("-");
      // let inputStr = this.value.split("/")[1];
      this.selected.inputValue = this.value.split("/")[1];
      this.selected.selectValue = this.value.split("/")[0].split("-");
    }
    this.initData();
  },
};
</script>

<style scoped lang="scss">
</style>
